import React, { useState, createContext, useContext, useEffect } from 'react';

interface ThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeContext = createContext<any>(null);

export const useThemeContext = () => {
  return useContext(ThemeContext);
};

export const CustomThemeProvider = ({ children }: ThemeProviderProps) => {
  const body = document.body;
  const storedTheme = localStorage.getItem('theme') || 'light';
  const [theme, setTheme] = useState(storedTheme);

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    localStorage.setItem('theme', newTheme as string);
    body.dataset.theme = newTheme;
    setTheme(newTheme);
  };

  useEffect(() => {
    body.dataset.theme = storedTheme;
  }, [storedTheme]);

  const values = {
    theme,
    setTheme,
    toggleTheme,
  };

  return <ThemeContext.Provider value={values}>{children}</ThemeContext.Provider>;
};
